import { combineReducers } from '@reduxjs/toolkit'
import newOwnerDetailsReducer from './newOwnerDetails'
import NewOwnersReducer from './newOwners'
import SubleaseReducer from '../../Sublease/shared/store/sublease'

const taskReducer = combineReducers({
  sublease: SubleaseReducer,
  newOwners: NewOwnersReducer,
  newOwnersDetails: newOwnerDetailsReducer,
})

export default taskReducer
